(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  }

  function icon(name) {
    var paths = {
      book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z"/>',
      flask: '<path d="M10 2v7.5L4.6 18a2 2 0 0 0 1.7 3h11.4a2 2 0 0 0 1.7-3L14 9.5V2"/><path d="M8.5 2h7"/>',
      wallet: '<path d="M20 7H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/><path d="M16 12h.01"/><path d="M2 9V6a2 2 0 0 1 2-2h12"/>',
      hospital: '<path d="M3 21h18M6 21V8l6-5 6 5v13M10 21v-6h4v6"/><path d="M10 11h4M12 9v4"/>',
      help: '<circle cx="12" cy="12" r="10"/><path d="M9.1 9a3 3 0 1 1 5.8 1c0 2-3 2-3 4"/><path d="M12 17h.01"/>',
      route: '<circle cx="6" cy="19" r="3"/><circle cx="18" cy="5" r="3"/><path d="M9 19h3.5a3.5 3.5 0 0 0 0-7H11a3.5 3.5 0 0 1 0-7H15"/>',
      steth: '<path d="M4 4v8a4 4 0 0 0 8 0V4"/><path d="M8 4v8"/><circle cx="18" cy="16" r="3"/><path d="M12 12a6 6 0 0 0 6 4"/>'
    };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' + (paths[name] || paths.book) + "</svg>";
  }

  ready(function () {
    if (typeof window.ushareApplyI18n === "function") window.ushareApplyI18n();
    if (!document.querySelector("[data-ushare-guides]")) return;
    var root = document;
    var cats = window.USHARE_GUIDE_CATS || [];
    var items = window.USHARE_GUIDES || [];
    var imgs = window.USHARE_GD_IMGS || {};
    var copy = window.USHARE_GD_COPY || {};
    var catBox = root.querySelector("[data-gd-cats]");
    var grid = root.querySelector("[data-gd-grid]");
    var countEl = root.querySelector("[data-gd-count]");
    var qInput = root.querySelector("[data-gd-q]");
    var sortEl = root.querySelector("[data-gd-sort]");
    var catIcons = {
      "china-healthcare-guides": "book",
      "clinical-trials-advanced-treatments": "flask",
      "cost-insurance-guides": "wallet",
      "hospital-guides": "hospital",
      "patient-education-faq": "help",
      "patient-journey-guides": "route",
      "treatment-guides": "steth"
    };
    cats = cats.slice().sort(function (a, b) {
      return (Number(a.sort) || 0) - (Number(b.sort) || 0);
    });
    cats.forEach(function (c) {
      c.n = items.filter(function (g) { return g.c === c.s; }).length;
    });
    var catTitles = {};
    cats.forEach(function (c) { catTitles[c.s] = c.t; });

    var params = new URLSearchParams(window.location.search);
    var knownCats = {};
    cats.forEach(function (c) { knownCats[c.s] = true; });
    var initialCat = params.get("cat") || params.get("category") || "";
    var state = {
      cat: knownCats[initialCat] ? initialCat : "",
      q: params.get("q") || "",
      sort: params.get("sort") === "title" ? "title" : "recent"
    };
    if (qInput) qInput.value = state.q;
    if (sortEl) sortEl.value = state.sort;

    function syncUrl() {
      var url = new URL(window.location.href);
      if (state.cat) url.searchParams.set("cat", state.cat);
      else url.searchParams.delete("cat");
      url.searchParams.delete("category");
      if (state.q.trim()) url.searchParams.set("q", state.q.trim());
      else url.searchParams.delete("q");
      if (state.sort === "title") url.searchParams.set("sort", "title");
      else url.searchParams.delete("sort");
      history.replaceState({}, "", url);
    }

    function filtered() {
      var q = (state.q || "").trim().toLowerCase();
      var list = items.filter(function (g) {
        if (state.cat && g.c !== state.cat) return false;
        if (!q) return true;
        return (g.t + " " + g.b).toLowerCase().indexOf(q) !== -1;
      });
      if (state.sort === "title") {
        list.sort(function (a, b) { return a.t.localeCompare(b.t); });
      } else {
        list.sort(function (a, b) {
          if (a.u === b.u) return a.i - b.i;
          return a.u < b.u ? 1 : -1;
        });
      }
      return list;
    }

    function renderCats() {
      catBox.innerHTML = cats.map(function (c) {
        return (
          '<button class="ushare-gd-cat' + (state.cat === c.s ? " is-active" : "") + '" type="button" data-cat="' + esc(c.s) + '">' +
            icon(c.icon || catIcons[c.s]) +
            "<span>" + esc(c.t) + "</span>" +
            "<em>" + c.n + "</em>" +
          "</button>"
        );
      }).join("");
    }

    function render() {
      var list = filtered();
      countEl.textContent = (copy.found || "{{ n }} guides found").replace("{{ n }}", String(list.length));
      if (!list.length) {
        grid.innerHTML = '<p class="ushare-gd-empty">' + esc(copy.empty || "") + "</p>";
        return;
      }
      grid.innerHTML = list.map(function (g) {
        var src = g.img || imgs[g.c] || "";
        var href = (window.ushareUrl || String)(g.url || "/pages/" + encodeURIComponent(g.s));
        return (
          '<a class="ushare-gd-card" href="' + esc(href) + '">' +
            '<div class="ushare-gd-card__photo">' +
              (src ? '<img src="' + esc(src) + '" alt="" width="800" height="450" loading="lazy">' : "") +
            "</div>" +
            '<div class="ushare-gd-card__body">' +
              '<span class="ushare-gd-tag">' + esc(catTitles[g.c] || "") + "</span>" +
              "<h3>" + esc(g.t) + "</h3>" +
              "<p>" + esc(g.b || "") + "</p>" +
              '<div class="ushare-gd-meta">' +
                "<span>" +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/></svg>' +
                  (copy.updated || "Updated {{ date }}").replace("{{ date }}", esc(g.u)) +
                "</span>" +
                "<span>" +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
                  (copy.read || "{{ n }} min read").replace("{{ n }}", String(g.m)) +
                "</span>" +
              "</div>" +
              '<span class="ushare-gd-read">' + esc(copy.more || "Read guide") + " ›</span>" +
            "</div>" +
          "</a>"
        );
      }).join("");
    }

    catBox.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-cat]");
      if (!btn) return;
      var next = btn.getAttribute("data-cat") || "";
      state.cat = state.cat === next ? "" : next;
      renderCats();
      render();
      syncUrl();
    });
    root.querySelector("[data-gd-reset]").addEventListener("click", function () {
      state.cat = "";
      state.q = "";
      state.sort = "recent";
      if (qInput) qInput.value = "";
      if (sortEl) sortEl.value = "recent";
      renderCats();
      render();
      syncUrl();
    });
    qInput.addEventListener("input", function () {
      state.q = qInput.value;
      render();
      syncUrl();
    });
    sortEl.addEventListener("change", function () {
      state.sort = sortEl.value === "title" ? "title" : "recent";
      render();
      syncUrl();
    });

    renderCats();
    render();
    syncUrl();
  });
})();
